import axios from "axios";
import { getToken, setToken } from "./auth";
const basicAuthorization =
  "Basic " + btoa("web_app:spring-microservice-exam-secret");

// create an axios instance
const service = axios.create({
  baseURL: "",
  timeout: 50000,
});

// setToken('eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImJhZWwta2V5LWlkIn0.eyJ1bmlvbmlkIjoib2tYNEk2aXMtblk0S1p5c1NKWV9ZUjV3RDROZyIsImxvZ2luVHlwZSI6IldYIiwidXNlcl9uYW1lIjoib1lpY3M2OGRuYS1EVC1EMmlnSnJUdm5TR08ydyIsInNjb3BlIjpbInJlYWQiLCJ3cml0ZSJdLCJ0ZW5hbnRDb2RlIjoxLCJleHAiOjE3MTA4MzQxODgsImp0aSI6IjgzMjlhZDU4LTFhZmItNGQ1NS05MTM1LTg4ZDRlZDA3ZDZiYyIsImNsaWVudF9pZCI6IndlYl9hcHAifQ.LaQUKvOEgroiYhDKMDp0Sni9mcqf7TDeXIva0JkGZOMQFf4js9NbrixWrrc1K2lRuUsrtGjW3XEN9gWIKITVOctc1D1Ujbq4CVEWtRfRXYEoNWILDT3XFvJ8JD0pCptJri8lAv_qqEGC521ZCHWap-cfUyyJlh8tGi5mkpZcyGlSxJTzwxyXkzuNUVW3CRyPNX6-DBXpES7WddwpxpF069atqTRLtYnh1bJAZ3deuMIQ0KWfr2XlYTQ2fkLRzMKeB_0qNib5CK9YlyC6ySM5f4vxtPLb3ailykFOQLhAqID67WtdSAyCXzBV5ttF0DIohl8kqZM9y8JbpJvsj4P6CA')

// request interceptor
service.interceptors.request.use(
  (config) => {
    const authorization = config.headers["Authorization"];
    if (authorization === undefined || authorization.indexOf("Basic") === -1) {
      config.headers["Authorization"] =
        getToken() && config.headers?.noAuth?.toString() !== "true"
          ? "Bearer " + getToken()
          : basicAuthorization; // 让每个请求携带token
    }
    // 接口调用未设置时设置默认租户
    if (!config.headers["Tenant-Code"]) config.headers["Tenant-Code"] = 1;
    return config;
  },
  (error) => {
    // console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    return res;
  },
  (error) => {
    // console.log('err', error.response) // for debug
    return Promise.reject(error.response);
  }
);

export default service;
